import http from '@/utils/http'

export const loadRules = (nodeID, params = {}) => http.get(`/kuiper/${nodeID}/rules`, { params })

export const createRule = (nodeID, body = {}) => http.post(`/kuiper/${nodeID}/rules`, body)

export const viewRule = (nodeID, id) => http.get(`/kuiper/${nodeID}/rules/${id}`)

export const deleteRule = (nodeID, id) => http.delete(`/kuiper/${nodeID}/rules/${id}`)

export const updateRule = (nodeID, id, body = {}) => http.put(`/kuiper/${nodeID}/rules/${id}`, body)

export const viewRuleStatus = (nodeID, id) => http.get(`/kuiper/${nodeID}/rules/${id}/status`)

export const restartRule = (nodeID, id) => http.post(`/kuiper/${nodeID}/rules/${id}/restart`)

export const startRule = (nodeID, id) => http.post(`/kuiper/${nodeID}/rules/${id}/start`)

export const stopRule = (nodeID, id) => http.post(`/kuiper/${nodeID}/rules/${id}/stop`)

export const loadRuleTopo = (nodeID, id) => http.get(`/kuiper/${nodeID}/rules/${id}/topo`)

export const getRuleSinks = (nodeID, name, params = {}) => {
  let getUrl = `/kuiper/${nodeID}/metadata/sinks`
  if (name) {
    getUrl = `${getUrl}/${name}`
  }
  return http.get(getUrl, { params })
}

export const loadAllFunctions = (nodeID) => http.get(`/kuiper/${nodeID}/metadata/functions`)

export const batchExportRules = (nodeID, body = []) => http.post(`/kuiper/${nodeID}/data/export`, body)
export const batchImportRules = (nodeID, body = {}) => http.post(`/kuiper/${nodeID}/data/import?partial=1`, body)

export default {}
